// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__31itt","title":"styles_title__20oSh","switcher":"styles_switcher__2WZTd","label":"styles_label__3y378"};